import { Component, OnDestroy, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { InvoiceService } from '../../service/data/invoice.service';
import { Invoice } from '../../model/invoice';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LocalDate } from '../../../core/model/local-date';
import { Money } from '../../../core/model/money';
import { MoneyValidator } from '../../../core/service/money-validator';

@Component({
    selector: 'app-customer-loss-form',
    templateUrl: './customer-loss-form.component.html',
    styleUrls: ['./customer-loss-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegisterCustomerLossFormComponent implements OnDestroy, OnInit {
  constructor(
    private _dialogService: ActionWindowService,
    private _dataService: InvoiceService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory
  ) {}

  @Input() dataContext: Invoice;

  private _s: Subscription = new Subscription();
  form: FormGroup;
  hasOngoingAmortizationPlan: boolean;

  cancel() {
    this._dialogService.close();
  }

  ngOnDestroy() {
    this._s.unsubscribe();
    this._initSub.unsubscribe();
  }

  private _initSub: Subscription = new Subscription();

  get errorMessage(): string {
    const value = this.form.controls['amount'].value;

    if (value == null) {
      return null;
    }

    const amount =
      value instanceof Money
        ? value.amount
        : value?.amount ?? Number(value);

    if (isNaN(amount)) {
      return null;
    }

    return amount > this.dataContext.remainingAmount.amount
      ? 'ERROR.CUSTOMER_LOSS_AMOUNT'
      : null;
  }

  sumForm: FormGroup;

  ngOnInit() {
    this.form = this._fb.group({
      amount: this._fcf.createWithOptions(
        'INVOICE.CUSTOMER_LOSS_AMOUNT',
        new Money(this.dataContext.remainingAmount.currencyCode, this.dataContext.remainingAmount.amount),
        { validator: Validators.compose([MoneyValidator.moneyMin(1), MoneyValidator.required()]) }
      ),
      id: this._fcf.createHidden(this.dataContext.id),
      verificationBusinessTransactionDate: this._fcf.createWithOptions('ACCOUNT.ACCOUNTING_DATE', LocalDate.today(), {
        required: true,
        helpText: 'INVOICE.HELP_TEXT.CREDIT_ACCOUNTING_DATE',
      }),
    });

    this._initSub.add(
      this._dataService
        .hasOngoingAmortizationPlan(this.dataContext.id)
        .subscribe(result => (this.hasOngoingAmortizationPlan = result))
    );
  }

  onSubmit() {
    if (this.form.invalid || this.errorMessage || this.form.disabled) return;
    this.form.disable();
    this._s.add(
      this._dataService
        .registerCustomerLoss(this.form.value)
        .pipe(
          catchError(e => {
            this.form.enable();
            throw e;
          })
        )
        .pipe(
          tap(res => {
            this.dataContext.remainingAmount = res;
            this._dialogService.complete(res);
          })
        )
        .subscribe()
    );
  }
}
